import { useQuery, UseQueryOptions } from 'react-query';
import { http } from '~/src/services/requests';
import pdfCourtFormsApiService from '~/src/services/api/pdfCourtFormsApiService';
import { APIError } from '~/src/utils/error';

interface StateMetadata {
  [state: string]: string[];
}

interface RegionMap {
  [filterCategory: string]: string | null;
}

export interface TemplateMetadata {
  filter_categories: StateMetadata;
  region_map: RegionMap;
}

const useGetTemplateMetadata = (
  options: UseQueryOptions<TemplateMetadata, APIError> = {},
) => {
  return useQuery<TemplateMetadata, APIError>({
    queryKey: ['templateMetadata'],
    queryFn: async () => {
      const url = pdfCourtFormsApiService.getTemplateMetadata();
      const response = await http.innerSendAuthenticated(
        {
          relativePath: url,
          method: 'GET',
        },
        true,
      );
      return response;
    },
    ...options,
  });
};

export default useGetTemplateMetadata;
